import React from 'react';
import { Chip } from '@heroui/react';
import { Typography } from '../../../../components';
import { RefShareOrder, OrderStatus } from '../../../../api/services';
import { ClockIcGrey, RefreshGreyIc } from '../../../../components/icons';
import { formatTimeAgo } from '../../../../utils/formatTimeAgo';
import { useTranslations } from '../../../../contexts/translation.context';
import { Icon } from '@iconify/react';

interface CampaignStatusCellProps {
  order: RefShareOrder;
}

const getStatusConfig = (status: OrderStatus) => {
  switch (status) {
    case 'in_progress':
      return {
        text: 'Активная',
        dotColor: 'bg-[#17C964]',
      };
    case 'waiting':
      return {
        text: 'Принята',
        dotColor: 'bg-[#F5A524]',
      };
    case 'in_moderation':
      return {
        text: 'На модерации',
        dotColor: 'bg-[#7828C8]',
      };
    case 'canceled':
      return {
        text: 'Отменена',
        dotColor: 'bg-[#F31260]',
      };
    case 'completed':
    default:
      return {
        text: 'Неактивная',
        dotColor: 'bg-[#71717A]',
      };
  }
};

const CampaignStatusCell: React.FC<CampaignStatusCellProps> = ({ order }) => {
  const { t } = useTranslations();
  const statusConfig = getStatusConfig(order.status);

  const formatDate = (dateString?: string) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('ru-RU', {
      day: '2-digit',
      month: '2-digit',
      year: 'numeric',
    });
  };

  const lastUpdate = order.last_update || order.created_at;
  const timeAgo = lastUpdate ? formatTimeAgo(lastUpdate, t) : '';

  return (
    <div className="flex flex-col gap-[4px] py-2">
      {/* Status Chip */}
      <Chip
        className="rounded-lg bg-[#F4F4F5] text-[#11181C]"
        classNames={{
          base: 'h-[24px] px-[8px] py-[4px] gap-[4px]',
        }}
        startContent={
          <div className={`w-[7px] h-[7px] rounded-full ${statusConfig.dotColor}`}></div>
        }
      >
        <Typography variant="body3" className="text-[#11181C]">
          {statusConfig.text}
        </Typography>
      </Chip>

      {/* Start Date */}
      <div className="flex items-center gap-[4px]">
        <Icon icon="solar:calendar-linear" className="w-[14px] h-[14px] text-[#71717A]" />
        <span className="text-[12px] text-[#11181C] leading-[16px]">
          {formatDate(order.created_at)}
        </span>
      </div>

      {/* Last Update */}
      {timeAgo && (
        <div className="flex items-center flex-nowrap gap-[4px]">
          <RefreshGreyIc size={14} />
          <span className="text-[12px] text-[#71717A] whitespace-nowrap leading-[16px]">
            {timeAgo}
          </span>
        </div>
      )}
    </div>
  );
};

export default CampaignStatusCell;
